export default function(messages, namespace) {
    let response = {}
    const ns = namespace || "defaultNameSpace"
    response._namespace = ns
    Object.keys(messages).forEach(key => {
        response[key] = {
            id: `${response._namespace}.${messages[key]}`,
            defaultMessage: `#!#${response._namespace}.${key}#!#`
        }
    })

    return response
}

export const convertLangFile = (messages, _namespace) => {
    let rtn = {}
    Object.keys(messages).forEach(key => {
        let tmpKey = _namespace + "." + key
        rtn[tmpKey] = messages[key]
    })
    return rtn
}

export const getBrowserLanguage = () => {
    if (window.sessionStorage.getItem("maxiLocale")) {
        return window.sessionStorage.getItem("maxiLocale")
    }

    const nav = window.navigator
    if (nav.language) {
        let lang = nav.language.toUpperCase()
        if (lang === "ZH" || lang === "ZH-CN") {
            return "zh"
        }
        if (lang === "DE" || lang === "DE-DE") {
            return "de"
        }
    }
    return "en"
}